<template>
  <b-modal
    :id="`mc-modal-reschedule-order-${activity?.id}`"
    ref="mc-modal"
    size="md"
    centered
    scrollable
    :title="$t('fleetTask.rescheduleDeliveryModal.title')"
  >
    <div class="card-body p-2">
      <McAlert
        v-if="deliveryOrder?.status?.name === 'Diambil'"
        class="mb-3"
        variant="warning"
        :html="$t('fleetTask.rescheduleDeliveryModal.alert.deletePickupProof')"
        withIcon
        :withGap="false"
      />
      <p>
        <span>{{ $t('fleetTask.rescheduleDeliveryModal.confirmationText.beforeNumber') }}&nbsp;</span>
        <strong>{{ activity?.delivery_order?.number }}</strong>
        <span>{{ $t('fleetTask.rescheduleDeliveryModal.confirmationText.afterNumber') }}</span>
      </p>
      <p>
        <span>{{ $t('fleetTask.rescheduleDeliveryModal.description.beforeStatus') }}&nbsp;</span>
        <strong>{{ $t('fleetTask.rescheduleDeliveryModal.description.rescheduledStatus') }}&nbsp;</strong>
        <span>{{ $t('fleetTask.rescheduleDeliveryModal.description.afterStatus') }}&nbsp;</span>
        <strong>{{ fleetTask?.number }}</strong>
        <span>.</span>
      </p>

      <FormulateForm
        v-model="formValues"
        name="reason-form"
        @submit="handleSubmit"
        @failed-validation="handleFailedValidation"
      >
        <FormulateInput
          type="select-resourceful"
          name="reason-id"
          trackBy="id"
          validation="required"
          :label="$t('fleetTask.rescheduleDeliveryModal.fields.reason')"
          :placeholder="$t('fleetTask.rescheduleDeliveryModal.placeholder.reason')"
          :help="true"
          :optionLabelFn="({ item }) => item.reason"
          :optionsGetter="reasonGet"
          :validation-messages="{
            required: $t('fleetTask.rescheduleDeliveryModal.validation.required'),
          }"
        />
      </FormulateForm>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0 gap-2">
        <McButton variant="secondary" :text="$t('global.cancel')" @click="cancel" />
        <McButton
          :text="$t('fleetTask.rescheduleDeliveryModal.action.reschedule')"
          :disabled="disabled"
          @click="triggerSubmit"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McAlert from '@/components/McAlert'

import * as Transition from '@/services/rest-api/lib/delivery/transition'
import * as Reason from '@/services/rest-api/lib/delivery/reason'

import { EventBus } from '@/router/views/fleet-task/lib/event-bus'

export default {
  components: {
    McButton,
    McAlert,
  },
  props: {
    activity: {
      type: Object,
      default: () => ({}),
    },
    fleetTask: {
      type: Object,
      default: () => ({}),
    },
    deliveryOrder: {
      type: Object,
      default: () => ({}),
    },
    isLastPoint: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['transition'],
  data() {
    return {
      formValues: {},
      reasonGet: Reason.get("type eq 'RESCHEDULED'"),
      disabled: true,
    }
  },
  watch: {
    formValues: {
      handler() {
        const reasonId = this.formValues['reason-id']

        this.disabled = reasonId === null || reasonId === undefined
      },
      deep: true,
    },
  },
  methods: {
    triggerSubmit() {
      this.$formulate.submit('reason-form')
    },
    async handleSubmit(data) {
      const payload = {
        status: 'RESCHEDULED',
        fields: {
          rescheduled_reason_id: data['reason-id'],
        },
      }

      const deliveryOrderId = this.activity?.delivery_order?.id

      const res = await Transition.transition(deliveryOrderId, payload)

      if (res.status === 400) {
        this.$mcToast.error({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                html: this.$t('fleetTask.rescheduleDeliveryModal.toast.failed', {
                  number: this.activity?.delivery_order?.number,
                }),
              },
            ],
          },
        })
        this.$refs['mc-modal'].hide()
        return
      }

      this.$mcToast.success({
        component: 'McToastDynamicBody',
        props: {
          contents: [
            {
              html: this.$t('fleetTask.rescheduleDeliveryModal.toast.success', {
                number: this.activity?.delivery_order?.number,
              }),
            },
          ],
        },
      })

      if (this.isLastPoint && this.fleetTask.auto_end_type === 'ACTIVITIES_COMPLETION') {
        this.$mcToast.success({
          component: 'McToastDynamicBody',
          props: {
            contents: [
              {
                html: this.$t('fleetTask.rescheduleDeliveryModal.toast.autoCompleted', {
                  number: this.fleetTask?.number,
                }),
              },
            ],
          },
        })
      }

      this.$refs['mc-modal'].hide()
      EventBus.$emit('refetch-sequence')
    },
    handleFailedValidation(_field) {
      this.$mcToast.error(this.$t('fleetTask.rescheduleDeliveryModal.validation.invalidInput'))
    },
    show() {
      this.$refs['mc-modal'].show()
    },
    hide() {
      this.$refs['mc-modal'].hide()
    },
  },
}
</script>

<style>
.__transition-icon {
  font-size: 20px;
  vertical-align: middle;
  margin: 0 10px;

  &::before {
    color: #4a90e1;
  }
}

strong {
  font-weight: bold;
}
</style>
